var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('Overview'),_c('About'),_c('ProgramHighlights'),_c('WhyChooseWTI'),_c('DetailsPage'),_c('AlumniTestimonials'),_c('ThesisTeam'),_c('FAQ'),_c('FutureOfConservation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }